import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { injectIntl, FormattedMessage } from 'react-intl';

import { Button } from '@salesforce/design-system-react';

import { AssetClassFilter, AssetCustomFilter } from '../index';

import './AssetFilterPane.scss';

class AssetFilterPane extends Component {
  constructor(props) {
    super(props);

    // inProgressFilter is the index of a new filter that should have an open popover
    this.state = { inProgressFilter: undefined };
  }

  /**
   * Handler that adds a new empty filter to the list of custom filters
   * updates the inProgressFilter index so that it automatically opens the popover
   */
  addCustomFilter() {
    const customFilters = this.props.filter.customFilters || [];
    const filter = { property: undefined };
    customFilters.push(filter);
    this.props.actions.updateAssetFilter({ customFilters });
    this.setState({
      inProgressFilter: customFilters.indexOf(filter)
    });
  }

  /**
   * Handler that takes a filter and an update and applies the changes to redux
   * Also clears the inProgressFilter which will close the filter popover
   * This is what does the dirty work when the user clicks "Done" in the filter
   * popover
   *
   * @param filter -- the filter to update
   * @param update -- the update to merge
   */
  updateCustomFilter(filter, update) {
    const customFilters = [...(this.props.filter.customFilters || [])];
    const idx = customFilters.indexOf(filter);
    customFilters[idx] = {
      ...customFilters[idx],
      ...update
    };
    this.props.actions.updateAssetFilter({ customFilters });
    this.setState({ inProgressFilter: null });
  }

  /**
   * Removes a filter from redux and clears the inProgressFilter which will close
   * the filter popover
   *
   * @param filterToRemove -- the filter to remove
   */
  removeCustomFilter(filterToRemove) {
    const filters = this.props.filter.customFilters || [];
    const customFilters = filters.filter(filter => filter !== filterToRemove);
    this.props.actions.updateAssetFilter({ customFilters });
    this.setState({ inProgressFilter: null });
  }

  renderAdditionalFilters() {
    const filters = this.props.filter.customFilters || [];
    return (
      <div className="additional-filters-list">
        {filters.map((filter, idx) => (
          <AssetCustomFilter
            key={`asset-filter-${idx}`}
            filter={filter}
            attributes={this.props.attributes}
            customFilters={filters}
            onChange={update => this.updateCustomFilter(filter, update)}
            onRemove={() => this.removeCustomFilter(filter)}
            inProgress={this.state.inProgressFilter === idx}
          />
        ))}
      </div>
    );
  }

  /**
   * Closes any open popovers and resets redux filters to nothing
   */
  handleRemoveAllFilters() {
    this.setState({
      inProgressFilter: null
    });
    this.props.actions.updateAssetFilter({
      assetClass: null,
      customFilters: null
    });
  }

  render() {
    return (
      <div className="filter-pane">
        <div className="filter-title-box">
          <div className="filter-title">
            <FormattedMessage id="components.ecs.assetFilter.filter" />
          </div>
          <Button
            className="close-filter"
            iconCategory="utility"
            iconName="close"
            iconSize="medium"
            variant="base"
            onClick={this.props.onClose}
          />
        </div>
        <AssetClassFilter {...this.props} />
        <div className="additional-filters">
          <div className="additional-filter-header">
            <FormattedMessage id="components.ecs.assetFilter.matching" />
          </div>
          {this.renderAdditionalFilters()}
          <div className="filter-actions">
            <span className="link" onClick={this.addCustomFilter.bind(this)}>
              <FormattedMessage id="components.ecs.assetFilter.addFilter" />
            </span>
            <span
              className="link remove-all-link"
              onClick={this.handleRemoveAllFilters.bind(this)}
            >
              <FormattedMessage id="components.ecs.assetFilter.removeAll" />
            </span>
          </div>
        </div>
      </div>
    );
  }
}

AssetFilterPane.propTypes = {
  actions: PropTypes.object,
  assetTypes: PropTypes.array,
  filter: PropTypes.object.isRequired,
  attributes: PropTypes.object,
  onClose: PropTypes.func.isRequired,
  location: PropTypes.object
};

export default injectIntl(AssetFilterPane);
